import { fetcher } from '@commenda/utils';

import { FilingConductorResyncResponse } from './types';

export interface ResyncFilingConductorIntegrationParams {
  corporationId: number;
  rootFiCompanyId: number;
  /** Analysis-window start (ISO date) — RootFi resyncs records on/after this date. */
  syncFromDate: string;
  token?: string;
}

export interface ResyncFilingConductorIntegrationResult {
  success: boolean;
  data?: FilingConductorResyncResponse;
  error?: string;
}

/** Starts a RootFi resync for one integration and records the rootfi_sync job. */
export async function resyncFilingConductorIntegration({
  corporationId,
  rootFiCompanyId,
  syncFromDate,
  token,
}: ResyncFilingConductorIntegrationParams): Promise<ResyncFilingConductorIntegrationResult> {
  try {
    const response = await fetcher(
      `filing-conductor/corporations/${corporationId}/integrations/${rootFiCompanyId}/resync`,
      { method: 'POST', body: { syncFromDate } },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return { success: false, error: json?.message || 'Failed to start resync' };
    }
    return { success: true, data: json as FilingConductorResyncResponse };
  } catch (error) {
    return { success: false, error: error instanceof Error ? error.message : 'Failed to start resync' };
  }
}
